import type { FeatureRoute } from '../types';
import { SupportPage } from './SupportPage';

/** Routes owned by this feature. */
export const routes: FeatureRoute[] = [{ path: 'support', element: <SupportPage /> }];
